// shortcut: чистый порт запрос/ответ Blanc-SBP (Tinkoff-совместимый протокол) без подписи Token
// и без сетевого вызова; сам fetch + поллинг статуса + вычисление Token живут в воркере (План 2,
// доступ к секрету TerminalPassword). Здесь — детерминированная сборка payload и маппинг статуса.
export type SbpConfig = { terminalKey: string; baseUrl: string };
export type SbpQrRequest = { url: string; method: "POST"; body: Record<string, unknown> };

export function buildSbpQrRequest(
  cfg: SbpConfig, params: { orderId: string; amountKopecks: number; description?: string },
): SbpQrRequest {
  const body: Record<string, unknown> = {
    TerminalKey: cfg.terminalKey,
    Amount: params.amountKopecks,
    OrderId: params.orderId,
  };
  if (params.description !== undefined) body.Description = params.description;
  return { url: `${cfg.baseUrl}/Init`, method: "POST", body };
}

export type SbpStatus = "pending" | "paid" | "failed";

const PAID = new Set(["AUTHORIZED", "CONFIRMED"]);
const FAILED = new Set(["REJECTED", "CANCELED", "DEADLINE_EXPIRED", "REVERSED", "REFUNDED"]);

export function parseSbpStatus(raw: { Status?: string }): SbpStatus {
  const s = raw.Status ?? "";
  if (PAID.has(s)) return "paid";
  if (FAILED.has(s)) return "failed";
  return "pending";
}
